import { type QuestionTypeChipProps } from '../components';

const QUESTION_TYPE_MAPPER: Record<string, QuestionTypeChipProps['type']> = {
  SINGLE: 'single',
  ITEM_SET: 'item-set',
};

export function getQuestionChipType(questionType: string) {
  return (
    QUESTION_TYPE_MAPPER[questionType as keyof typeof QUESTION_TYPE_MAPPER] ??
    QUESTION_TYPE_MAPPER.SINGLE
  );
}
